import React from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import TabbedView from "../../App/Components/TabbedView/TabbedView";
import FeaturedJobsDisplayPage from "./Components/Tabs/FeaturedJobs/FeaturedJobsDisplay";
import FeaturedJobGroupsDisplayPage from "./Components/Tabs/FeaturedJobGroups/FeaturedJobGroupsDisplay";
import TalentNetworkDisplayPage from "./Components/Tabs/TalentNetwork/TalentNetworkDisplay";
import JobDetailsDisplayPage from "./Components/Tabs/JobDetails/JobDetailsDisplayPage";

function DisplayPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    autocomplete: {
      width: "35%",
      paddingBottom: "20px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);

  const tabs = [
    { title: "Featured Jobs", component: <FeaturedJobsDisplayPage /> },
    {
      title: "Featured Job Groups",
      component: <FeaturedJobGroupsDisplayPage />,
    },
    { title: "Talent Network", component: <TalentNetworkDisplayPage /> },
    { title: "Job Details", component: <JobDetailsDisplayPage /> },
  ];

  return (
    <>
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">{selectCareersClient.shortName} Display</h1>
        <div className={classes.root}>
          <TabbedView tabs={tabs} />
        </div>
      </div>
    </>
  );
}

export default DisplayPage;
